/* Выбор из справочника */
(function ($) {
  $.fn.extend({
    ReferenceSelect: function (options, img) {
      if (options.multiselect) {
        this.data('ReferenceSelectInstance', new Core.requisites.ReferenceMultiSelect(this, options, img));
      } else {
        this.data('ReferenceSelectInstance', new Core.requisites.ReferenceSelect(this, options, img));
      }
      this.trigger('Init');
      return this;
    },
    SetSelected: function (v) {
      this.trigger('SetSelected', [v]);
    },
    result: function (handler) {
      return this.bind("result", handler);
    },
    resultMulti: function (handler) {
      return this.bind("resultMulti", handler);
    },
    ReplaceSelectedItem: function (oldID, newValues) {
      this.trigger('ReplaceSelectedItem', [oldID, newValues, false]);
    },
    ReplaceLastSelectedItem: function (oldID, newValues) {
      this.trigger('ReplaceSelectedItem', [oldID, newValues, true]);
    },
    Clear: function () {
      this.trigger("Clear");
    },
    HideContainer: function () {
      this.trigger("HideContainer");
    },
    SetValue: function (val, needTriggerResult) {
      this.trigger("SetValue", [val, needTriggerResult]);
      return $(this);
    },
    SetValues: function (values, needTriggerResult) {
      this.trigger("SetValues", [values, needTriggerResult]);
      return $(this);
    },
    SetDisabled: function () {
      this.trigger("SetDisabled", [true]);
      return $(this);
    },
    SetEnabled: function () {
      this.trigger("SetDisabled", [false]);
      return $(this);
    }
  });
})(jQuery);
